import React from 'react';
import RevealTime from "./SettingOptions/Bookings/RevealTime";
import * as yup from "yup";
import {t} from "../../../../../services/i18n";
import {store} from "../../../../../redux/store";
import {Colors} from "../../../../../styles/Colors";
import {GlobalStyleAttributes} from "../../../../../styles/GlobalStyles";
import ClassSwapping from "./SettingOptions/Bookings/ClassSwapping";
import WaitListEntrance from "./SettingOptions/WaitingList/WaitListEntrance";
import CancellationTime from "./SettingOptions/WaitingList/CancellationTime";
import SmsNotification from "./SettingOptions/Notifications/SmsNotification";
import AppointmentPolicy from "./SettingOptions/AppointmentPolicy/AppointmentPolicy";
import EmbedSchedule from "./SettingOptions/EmbedSchedule/EmbedSchedule";
import {getBoxSegment, getBoxTimeFormat, isBoxIL, isMobile} from "../../../../../services/Helpers";
import WaitListEntranceApproval from './SettingOptions/WaitingList/WaitListEntranceApproval';
import QuickViewDisplay from "./SettingOptions/EmbedSchedule/QuickViewDisplay";
import CustomFields from "./SettingOptions/CustomFields/CustomFields";
import {
    closeModal,
    FLOW_MANAGER_MODAL,
    openModal,
    SCHEDULE_SETTINGS_MODAL
} from "../../../../../redux/modalManagerSlice";
import AutoMessages from "./SettingOptions/Notifications/AutoMessages";
import ActiveIndicator from "./SettingOptions/Notifications/ActiveIndicator";
import {modalFlowOptions} from "../../../Popups/ModalFlow/ModalFlowOptions";
import WhatsappNotification from './SettingOptions/Notifications/WhatsappNotification';
import {
    AVAILABILITY_REVEAL_TIME,
    DEFAULT_SCHEDULE_VIEW,
    MISSING_USER_NOTE_INDICATOR,
    SCHEDULE_SETTINGS,
    TRIAL_LIMIT_SETTING, WORKING_HOURS_SETTING
} from '../../../../../services/ConstHelper';
import {resolveDefaultScheduleType} from "../../../../../services/ScheduleService";
import QrNotification from './SettingOptions/Notifications/QrNotification';
import TrialLimit from "./SettingOptions/WaitingList/TrialLimit";
import TrialAutoMessages from "./SettingOptions/Notifications/TrialAutoMessages";
import MissingUserNote from "./SettingOptions/AppointmentPolicy/MissingUserNote";
import AppointmentConfirmation from "./SettingOptions/AppointmentConfirmation/AppointmentConfirmation";
import DoctorJournalSetting from "./SettingOptions/DoctorJournalSetting";
import AvailabilityRevealTime from "./SettingOptions/Bookings/AvailabilityRevealTime";
import {
    applyScheduleSettingsSegmentLayout,
} from "./scheduleSettingsSegmentLayout";
import WorkingHours from "./SettingOptions/General/WorkingHours";
import DefaultScheduleView from "./SettingOptions/General/DefaultScheduleView";
import moment from "moment";
import GoogleCalendarSync from "./SettingOptions/CalendarSync/GoogleCalendarSync";
import GoogleCalendarSyncMultiStaff from "./SettingOptions/CalendarSync/GoogleCalendarSyncMultiStaff";
import ScheduleCancelReason from "./SettingOptions/ScheduleCancelReason/ScheduleCancelReason";

export const getScheduleSettingsConfig = (has, dispatch, hasLock) => {
    const box = store.getState().box.box
    const tabs = [
        {
            id: 'bookings',
            title: 'bookings',
            options: [
                {
                    header: 'futureSessionRevealingTime',
                    subheader: t('SetTimeToRevealTxt'),
                    explanation: 'SetTimeToRevealTxt',
                    tooltipText: t('display-classes-tooltip-text'),
                    hide: has('classesLock'),
                    body: <RevealTime/>,
                    validationSchema: yup.object().shape({
                        revealWeeks: yup.number().min(0, t('onlyPositive')).required(t('thisFieldIsMandatory')).typeError(t('onlyPositive')),
                        revealDay: yup.number().min(0).max(6).required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
                        revealTime: yup.string().nullable().typeError(t('thisFieldIsMandatory'))
                    }),
                    initialValues: {revealWeeks: box.showing_classes_week_ago || 0, revealDay: box.showing_classes_day_ago || 0, revealTime: box.showing_classes_time_ago || null}
                },
                {
                    header: 'futureAvailabilityRevealingTime',
                    subheader: t('setTimeToRevealAvailabilityTxt'),
                    explanation: 'setTimeToRevealAvailabilityTxt',
                    tooltipText: t('display-availability-tooltip-text'),
                    hide: has('availabilityLock'),
                    body: <AvailabilityRevealTime />,
                    validationSchema: yup.object().shape({
                        availabilityReveal: yup.object().shape({
                            revealWeeks: yup.number().min(0, t('onlyPositive')).required(t('thisFieldIsMandatory')).typeError(t('onlyPositive')),
                            revealDay: yup.number().min(0).max(6).required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
                            revealTime: yup.string().nullable().typeError(t('thisFieldIsMandatory'))
                        })
                    }),
                    initialValues: getAvailabilityRevealTimeSettings()
                },
                {
                    header: 'sessionSwappingLbl',
                    subheader: `${box.schedule_swapping_time} ${t('hoursAfterCancellation')}`,
                    explanation: 'sessionSwappingTxt',
                    tooltipText: t('classes-swapping-tooltip-text'),
                    hide: has('classesLock'),
                    body: <ClassSwapping/>,
                    validationSchema: yup.object().shape({
                        swapMinutes: yup.number().min(0, t('onlyPositive')).required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
                        allowWaitlist: yup.boolean(),
                        swapMaxHours: yup.number().min(0, t('onlyPositive')).max(24, t('max-hours-24')).nullable()
                    }),
                    initialValues: {
                        swapMinutes: box.schedule_swapping_time || 0, allowWaitlist: box.schedule_swapping_standby_time > 0,
                        swapMaxHours: box.schedule_swap_max_hours === undefined ? (box.settings?.[SCHEDULE_SETTINGS]?.schedule_swap_max_hours || null) : box.schedule_swap_max_hours
                    }
                },
            ]
        },
        {
            id: 'notifications',
            title: 'notificationsSettingsLbl',
            options: [
                {
                    header: isMobile ? 'bookingReminderLbl' : '',
                    subheader: t('bookingReminderMobileTxt'),
                    body: isMobile ? null : <AutoMessages
                        messageType={autoMessageTypes.REMINDER_SESSION} sessionType={null}
                        header={t('bookingReminderLbl')} subheader={t('bookingReminderMobileTxt')}
                        periodAmountTextBefore={t('class-session-period-before')}
                        periodAmountTextAfter={t('class-session-period-after')}
                        sectionHeader={{title: t('autoMessageNotificationsLbl'), tooltip: t('session-auto-message-tooltip')}}/>,
                    validationSchema: yup.object().shape({}),
                    hide: has('classesLock'),
                    initialValues: {},
                    hideDivider: true,
                    headerStart: <ActiveIndicator isActive={getIsMessageTypeActive(autoMessageTypes.REMINDER_SESSION, null)}/>,
                    onClick: () => openAutoMessageModal(dispatch, autoMessageTypes.REMINDER_SESSION, null)
                },
                {
                    header: isMobile ? 'markCheckInMobileLbl' : '',
                    subheader: t('markCheckInMobileTxt'),
                    body: isMobile ? null : <AutoMessages messageType={autoMessageTypes.MARK_CHECK_IN} sessionType={null} header={t('markCheckInLbl')} subheader={t('markCheckInTxt')}/>,
                    validationSchema: yup.object().shape({}),
                    initialValues: {},
                    headerStart: <ActiveIndicator isActive={getIsMessageTypeActive(autoMessageTypes.MARK_CHECK_IN, null)}/>,
                    onClick: () => openAutoMessageModal(dispatch, autoMessageTypes.MARK_CHECK_IN, null)
                },
                {
                    header: isMobile ? 'smsNotificationLbl' : '',
                    subheader: t('smsNotificationTxt'),
                    explanation: null,
                    hide: has('classesLock'),
                    body: isMobile ? null : <SmsNotification/>,
                    sideOverride: isMobile ? <SmsNotification/> : null,
                    validationSchema: yup.object().shape({
                        allowSmsWaitList: yup.boolean()
                    }),
                    initialValues: { allowSmsWaitList: box.allow_sms_to_waiting_list || 0 }
                },
                ...(box.integrations?.find(i => i.name === 'greenApi' || i.name === 'metaWhatsapp') ? [{
                    header: isMobile ? 'whatsappNotificationLbl' : '',
                    subheader: t('whatsappNotificationTxt'),
                    explanation: null,
                    hide: has('classesLock'),
                    body: isMobile ? null : <WhatsappNotification/>,
                    sideOverride: isMobile ? <WhatsappNotification/> : null,
                    validationSchema: yup.object().shape({
                        allowWhatsappWaitList: yup.boolean().nullable()
                    }),
                    initialValues: { allowWhatsappWaitList: box.allow_whatsapp_to_waiting_list ?? (box.settings?.[SCHEDULE_SETTINGS]?.allow_whatsapp_to_waiting_list || 0) }
                }] : []),
                {
                    header: isMobile ? 'qrNotificationLbl' : '',
                    subheader: t('qrNotificationTxt'),
                    explanation: null,
                    permission: 'viewFreefit',
                    body: isMobile ? null : <QrNotification/>,
                    sideOverride: isMobile ? <QrNotification/> : null,
                    validationSchema: yup.object().shape({
                        sendQrMessage: yup.boolean()
                    }),
                    initialValues: { sendQrMessage: box.send_qr_messsage || false }
                },
                {
                    header: isMobile ? 'sessionReminderMobileLbl' : '',
                    subheader: t('sessionReminderMobileTxt'),
                    body: isMobile ? null : <AutoMessages messageType={autoMessageTypes.REMINDER_SESSION} sessionType={'appointment'} header={t('sessionReminderLbl')} subheader={t('sessionReminderTxt')} sectionHeader={{title: t('autoMessageLbl'), tooltip: t('session-auto-message-tooltip-appointments')}}/>,
                    validationSchema: yup.object().shape({}),
                    initialValues: {},
                    headerStart: <ActiveIndicator isActive={getIsMessageTypeActive(autoMessageTypes.REMINDER_SESSION)}/>,
                    hideDivider: true,
                    permission: 'appointmentAutoMessages',
                    onClick: () => openAutoMessageModal(dispatch, autoMessageTypes.REMINDER_SESSION)
                },
                {
                    header: isMobile ? 'secondSessionReminderMobileLbl' : '',
                    subheader: t('secondSessionReminderMobileTxt'),
                    hide: !getIsMessageTypeActive(autoMessageTypes.REMINDER_SESSION),
                    body: isMobile ? null : <AutoMessages messageType={autoMessageTypes.SECOND_REMINDER_SESSION} sessionType={'appointment'} header={t('secondSessionReminderLbl')} subheader={t('secondSessionReminderTxt')}/>,
                    validationSchema: yup.object().shape({}),
                    initialValues: {},
                    headerStart: <ActiveIndicator isActive={getIsMessageTypeActive(autoMessageTypes.SECOND_REMINDER_SESSION)}/>,
                    hideDivider: true,
                    permission: 'appointmentAutoMessages',
                    onClick: () => openAutoMessageModal(dispatch, autoMessageTypes.SECOND_REMINDER_SESSION)
                },
                {
                    header: isMobile ? 'bookSessionAutoMessageMobileLbl' : '',
                    subheader: t('bookSessionReminderMobileTxt'),
                    body: isMobile ? null : <AutoMessages messageType={autoMessageTypes.BOOK_SESSION} sessionType={'appointment'} header={t('bookSessionAutoMessageLbl')} subheader={t('bookSessionReminderTxt')}/>,
                    validationSchema: yup.object().shape({}),
                    initialValues: {},
                    headerStart: <ActiveIndicator isActive={getIsMessageTypeActive(autoMessageTypes.BOOK_SESSION)}/>,
                    hideDivider: true,
                    permission: 'appointmentAutoMessages',
                    onClick: () => openAutoMessageModal(dispatch, autoMessageTypes.BOOK_SESSION)
                },
                {
                    header: isMobile ? 'editSessionAutoMessageMobileLbl' : '',
                    subheader: t('editSessionReminderMobileTxt'),
                    body: isMobile ? null : <AutoMessages messageType={autoMessageTypes.EDIT_SESSION} sessionType={'appointment'} header={t('editSessionAutoMessageLbl')} subheader={t('editSessionReminderTxt')}/>,
                    validationSchema: yup.object().shape({}),
                    initialValues: {},
                    headerStart: <ActiveIndicator isActive={getIsMessageTypeActive(autoMessageTypes.EDIT_SESSION)}/>,
                    hideDivider: true,
                    permission: 'appointmentAutoMessages',
                    onClick: () => openAutoMessageModal(dispatch, autoMessageTypes.EDIT_SESSION)
                },
                {
                    header: isMobile ? 'afterSessionNotifyMobileLbl' : '',
                    subheader: t('afterSessionNotifyMobileTxt'),
                    body: isMobile ? null : <AutoMessages messageType={autoMessageTypes.AFTER_SESSION_NOTIFY} sessionType={'appointment'} header={t('afterSessionNotifyLbl')} subheader={t('afterSessionNotifyTxt')}/>,
                    validationSchema: yup.object().shape({}),
                    initialValues: {},
                    headerStart: <ActiveIndicator isActive={getIsMessageTypeActive(autoMessageTypes.AFTER_SESSION_NOTIFY)}/>,
                    hideDivider: true,
                    permission: 'appointmentAutoMessages',
                    onClick: () => openAutoMessageModal(dispatch, autoMessageTypes.AFTER_SESSION_NOTIFY)
                },
                {
                    header: isMobile ? 'cancelSessionAutoMessageMobileLbl' : '',
                    subheader: t('cancelSessionReminderMobileTxt'),
                    body: isMobile ? null : <AutoMessages messageType={autoMessageTypes.CANCEL_SESSION} sessionType={'appointment'} header={t('cancelSessionAutoMessageLbl')} subheader={t('cancelSessionReminderTxt')}/>,
                    validationSchema: yup.object().shape({}),
                    initialValues: {},
                    headerStart: <ActiveIndicator isActive={getIsMessageTypeActive(autoMessageTypes.CANCEL_SESSION)}/>,
                    permission: 'appointmentAutoMessages',
                    onClick: () => openAutoMessageModal(dispatch, autoMessageTypes.CANCEL_SESSION)
                },
                {
                    header: isMobile ? 'bookSessionStaffNotifyAutoMessageMobileLbl' : '',
                    subheader: t('bookSessionStaffNotifyMobileTxt'),
                    body: isMobile ? null : <AutoMessages messageType={autoMessageTypes.BOOK_SESSION_STAFF_NOTIFY} sessionType={'appointment'} header={t('bookSessionStaffNotifyLbl')} subheader={t('bookSessionStaffNotifyTxt')} sectionHeader={{title: t('autoMessageStaffLbl'), tooltip: t('autoMessageStaff-tooltip')}}/>,
                    validationSchema: yup.object().shape({}),
                    initialValues: {},
                    hideDivider: true,
                    permission: 'appointmentAutoMessages',
                    headerStart: <ActiveIndicator isActive={getIsMessageTypeActive(autoMessageTypes.BOOK_SESSION_STAFF_NOTIFY)} />,
                    onClick: () => openAutoMessageModal(dispatch, autoMessageTypes.BOOK_SESSION_STAFF_NOTIFY)
                },
                {
                    header: isMobile ? 'editSessionStaffNotifyAutoMessageMobileLbl' : '',
                    subheader: t('editSessionStaffNotifyMobileTxt'),
                    body: isMobile ? null : <AutoMessages messageType={autoMessageTypes.EDIT_SESSION_STAFF_NOTIFY} sessionType={'appointment'} header={t('editSessionStaffNotifyLbl')} subheader={t('editSessionStaffNotifyTxt')}/>,
                    validationSchema: yup.object().shape({}),
                    initialValues: {},
                    hideDivider: true,
                    permission: 'appointmentAutoMessages',
                    headerStart: <ActiveIndicator isActive={getIsMessageTypeActive(autoMessageTypes.EDIT_SESSION_STAFF_NOTIFY)} />,
                    onClick: () => openAutoMessageModal(dispatch, autoMessageTypes.EDIT_SESSION_STAFF_NOTIFY)
                },
                {
                    header: isMobile ? 'afterSessionStaffNotifyMobileLbl' : '',
                    subheader: t('afterSessionStaffNotifyMobileTxt'),
                    body: isMobile ? null : <AutoMessages messageType={autoMessageTypes.AFTER_SESSION_STAFF_NOTIFY} sessionType={'appointment'} header={t('afterSessionStaffNotifyLbl')} subheader={t('afterSessionStaffNotifyTxt')}/>,
                    validationSchema: yup.object().shape({}),
                    initialValues: {},
                    hideDivider: true,
                    permission: 'appointmentAutoMessages',
                    headerStart: <ActiveIndicator isActive={getIsMessageTypeActive(autoMessageTypes.AFTER_SESSION_STAFF_NOTIFY)} />,
                    onClick: () => openAutoMessageModal(dispatch, autoMessageTypes.AFTER_SESSION_STAFF_NOTIFY)
                },
                {
                    header: isMobile ? 'cancelSessionStaffNotifyAutoMessageMobileLbl' : '',
                    subheader: t('cancelSessionStaffNotifyMobileTxt'),
                    body: isMobile ? null : <AutoMessages messageType={autoMessageTypes.CANCEL_SESSION_STAFF_NOTIFY} sessionType={'appointment'} header={t('cancelSessionStaffNotifyLbl')} subheader={t('cancelSessionStaffNotifyTxt')}/>,
                    validationSchema: yup.object().shape({}),
                    initialValues: {},
                    permission: 'appointmentAutoMessages',
                    headerStart: <ActiveIndicator isActive={getIsMessageTypeActive(autoMessageTypes.CANCEL_SESSION_STAFF_NOTIFY)} />,
                    onClick: () => openAutoMessageModal(dispatch, autoMessageTypes.CANCEL_SESSION_STAFF_NOTIFY)
                },
            ]
        },
        {
            id: 'waitingList',
            title: 'waitingListSettingsLbl',
            hide: has('classesLock'),
            options: [
                {
                    header: 'waitListEntranceApproval',
                    subheader: null,
                    tooltipText: t('waitListEntranceApprovalTxt'),
                    body: <WaitListEntranceApproval/>,
                    validationSchema: yup.object().shape({
                        standbyTimeToApprove: yup.number().nullable().min(1, t('time-to-approve-range-1-60')).max(60, t('time-to-approve-range-1-60')).typeError(t('only-numbers'))
                    }),
                    initialValues: { standbyTimeToApprove: box.standby_time_to_approve},
                    permission: 'waitingListApproval'
                },
                {
                    header: 'ignoreWaitingListLbl',
                    subheader: `${box.schedule_standby_offset} ${t('beforeClassStarts')}`,
                    explanation: 'stopAddingClientsTxt',
                    // tooltipText: t('ignoreWaitingList-tooltip-text'),
                    body: <WaitListEntrance/>,
                    validationSchema: yup.object().shape({
                        waitListOffset: yup.number().min(0, t('onlyPositive')).required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory'))
                    }),
                    initialValues: { waitListOffset: box.schedule_standby_offset || 0}
                },
                {
                    header: isMobile ? 'cancelationTimeLbl' : '',
                    subheader: `${box.standby_cancellation_time} ${t('afterJoining')}`,
                    explanation: 'cancelationTimeTxt',
                    // tooltipText: t('cancellation-time-tooltip-text'),
                    body: <CancellationTime/>,
                    validationSchema: yup.object().shape({
                        cancellationTime: yup.number().min(0, t('onlyPositive')).required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory'))
                    }),
                    initialValues: { cancellationTime: box.standby_cancellation_time || 0}
                },
            ]
        },
        {
            id: 'trial',
            title: 'trialLbl',
            hide: !((has('bookForTrialClassSite') || has('bookForTrialHugim')) && !has('bookForTrialClassSiteLock')),
            options: [
                {
                    header: 'trialLimitHeader',
                    subheader: getTrialLimit() === 'unlimited' ? t('trial-unlimited-mobile') : t('trial-limit-to', {limit: getTrialLimit()}),
                    explanation: 'trialLimitHeaderTxt',
                    body: <TrialLimit/>,
                    validationSchema: yup.object().shape({
                        trialLimit: yup.mixed().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory'))
                            .test('is-number-or-unlimited', t('onlyPositive'), (value) => {
                                return value === 'unlimited' || (typeof value === 'number' && value >= 1);
                            })
                    }),
                    initialValues: { trialLimit: getTrialLimit()},
                },
                {
                    header: isMobile ? 'autoMessageTrialMobileLbl' : '',
                    subheader: null,
                    explanation: null,
                    body: <TrialAutoMessages/>,
                    validationSchema: yup.object().shape({}),
                    initialValues: {},
                    hideDivider: true,
                    hideMobileSave: true,
                    permission: 'appointmentAutoMessages',
                },
            ]
        },
        {
            id: 'cancellation',
            title: 'cancellationsPolicy',
            hasLock: has('appointmentsLock'),
            options: [
                { //FOR MERGE CONFILICTS - THIS SHOULD BE AFTER AUTO ACTIONS SETTINGS AND BEFORE CONFIRMATION SETTINGS!!
                    header: isMobile ? 'missingUserNoteLbl' : '',
                    subheader: t('missingUserNoteTxt'),
                    explanation: null,
                    permission: 'userNoteView',
                    body: isMobile ? null : <MissingUserNote/>,
                    sideOverride: isMobile ? <MissingUserNote/> : null,
                    validationSchema: yup.object().shape({
                        showMissingUserNote: yup.boolean()
                    }),
                    initialValues: { showMissingUserNote: getMissingUserNoteIndicator() }
                },
                {
                    header: isMobile ? 'appointmentConfirmation' : '',
                    subheader: null,
                    explanation: null,
                    body: <AppointmentConfirmation/>,
                    validationSchema: yup.object().shape({
                        confirmationSettings: yup.object().shape({
                            showStatusOnCalendar: yup.boolean().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
                            confirmationText: yup.string().nullable()
                        })
                    }),
                    initialValues: {
                        confirmationSettings: {
                            showStatusOnCalendar: box.settings?.confirmation_settings?.showStatusOnCalendar || false,
                            confirmationText: box.settings?.confirmation_settings?.confirmationText,
                            allowCancel: !!box.settings?.confirmation_settings?.allowCancel
                        }
                    },
                    permission: 'arrivalConfirmations',
                    hide: has('arrivalConfirmations') && hasLock('arrivalConfirmations')
                },
                {
                    header: isMobile ? 'cancellationsPolicy' : '',
                    subheader: null,
                    explanation: null,
                    body: <AppointmentPolicy/>,
                    validationSchema: yup.object().shape({
                        apptCancelTime: yup.number().min(0, t('onlyPositive')).typeError(t('thisFieldIsMandatory')),
                        apptCancelEnabled: yup.boolean().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
                        apptCancelPolicy: yup.string().nullable()
                    }),
                    initialValues: { apptCancelTime: box?.locations_box[0].availability_time_cancellation || 0,
                                     apptCancelEnabled: box?.locations_box[0].availability_enable_late_cancellation || false,
                                     apptCancelPolicy: box?.locations_box[0].cancellation_policy }
                },
                {
                    header: isMobile ? 'doctorJournalToggle' : '',
                    subheader: null,
                    explanation: null,
                    permission: 'doctorJournalSettings',
                    body: isMobile ? null : <DoctorJournalSetting/>,
                    sideOverride: isMobile ? <DoctorJournalSetting/> : null,
                    validationSchema: yup.object().shape({
                        doctorJournalEnabled: yup.boolean()
                    }),
                    initialValues: { doctorJournalEnabled: box?.settings?.doctor_journal_settings?.enabled ?? false }
                },
            ]
        },
        {
            id: 'calendarSync',
            title: 'calendarSync',
            hide: !has('calendarSync'),
            hasLock: has('googleCalendarSyncLock'),
            options: [
                {
                    header: isMobile ? 'calendarSync' : '',
                    subheader: null,
                    explanation: null,
                    body: <GoogleCalendarSync/>,
                    validationSchema: yup.object().shape({
                        googleSync: yup.object().shape({
                            check_for_conflicts: yup.boolean(),
                            add_to_calendar: yup.boolean(),
                        }).nullable()
                    }),
                    initialValues: {
                        googleSync: {
                            add_to_calendar: box.calendarSync?.add_to_calendar,
                            check_for_conflicts: box.calendarSync?.check_for_conflicts
                        }
                    },
                    hide: has('calendarSyncInvite') && !has('selfSyncCalendar')
                },
                {
                    header: isMobile ? 'calendarSync' : '',
                    subheader: null,
                    explanation: null,
                    body: <GoogleCalendarSyncMultiStaff/>,
                    validationSchema: yup.object().shape({}),
                    initialValues: {},
                    hide: (!has('selfSyncCalendar') && !has('calendarSyncInvite')) || has('selfSyncCalendar')
                }
            ]
        },
        {
            id: 'embedSchedule',
            title: 'embedScheduleLabel',
            hideOnMobile: true,
            options: [
                {
                    header: '',
                    subheader: null,
                    explanation: null,
                    body: <QuickViewDisplay />,
                    validationSchema: yup.object().shape({
                        showSchedulePreview: yup.number().min(0)
                    }),
                    initialValues: { showSchedulePreview: box?.show_schedule_preview },
                    hide: box.isBoxHasNewSite
                },
                {
                    header: 'embedSchedule',
                    subheader: null,
                    explanation: null,
                    body: <EmbedSchedule/>,
                    validationSchema: yup.object().shape({}),
                    initialValues: {}
                },
            ]
        },
        ...((has('customFieldSettingsLock') || has('editCustomField') || has('deleteCustomField') || has('addCustomField')) ? [{
            id: 'customFields',
            title: 'customFieldsLabel',
            hasLock: has('customFieldSettingsLock'),
            optionalLockCallback: () => dispatch(closeModal({ modalName: SCHEDULE_SETTINGS_MODAL })),
            options: [
                {
                    header: 'customFieldsLabel',
                    subheader: null,
                    explanation: null,
                    body: <CustomFields />,
                    initialValues: { showSchedulePreview: box?.show_schedule_preview }
                }
            ]
        }] : []),
        {
            id: 'scheduleCancelReasons',
            title: 'scheduleCancelReasonLabel',
            hide: !has('scheduleCancelReason'),
            hasInnerScroll: true,
            options: [
                {
                    header: 'scheduleCancelReasonHeader',
                    tooltipText: t('scheduleCancelReasonHeaderTooltip'),
                    subheader: null,
                    explanation: null,
                    body: <ScheduleCancelReason />,
                    initialValues: { }
                }
            ]
        },
        {
            id: 'general',
            title: 'quickViewLabel',
            hide: !box.isBoxHasNewSite,
            options: [
                {
                    header: isMobile ? 'showSchedulePreview' : '',
                    subheader: null,
                    explanation: null,
                    body: <QuickViewDisplay />,
                    validationSchema: yup.object().shape({
                        showSchedulePreview: yup.number().min(0)
                    }),
                    initialValues: { showSchedulePreview: box?.show_schedule_preview }
                },
                {
                    header: 'workingHoursTitle',
                    subheader: getWorkingHoursSubheader(),
                    permission: 'workingHoursSettings',
                    body: <WorkingHours />,
                    validationSchema: yup.object().shape({
                    }),
                    initialValues: {workingHours: getWorkingHoursSettings()}
                },
                {
                    header: 'defaultScheduleViewTitle',
                    subheader: null,
                    explanation: null,
                    permission: 'workingHoursSettings',
                    body: <DefaultScheduleView />,
                    validationSchema: yup.object().shape({
                        defaultScheduleView: yup.string()
                    }),
                    initialValues: {defaultScheduleView: getDefaultScheduleView(has, hasLock)}
                },
            ]
        },
    ]
    const segment = getBoxSegment(box)
    return applyScheduleSettingsSegmentLayout(tabs, segment)
}

const getTeamNotificationSubheader = (box) => {
    switch (box.notify_session_owner) {
        case 1:
            return 'notifySessionOwnerBySms'
        case 2:
            return 'notifySessionOwnerByEmail'
        case 3:
            return 'notifySessionOwnerBySmsAndEmail'
        default:
            return null
    }
}

export const autoMessageTypes = {
    MARK_CHECK_IN: 'MARK_CHECK_IN',
    BOOK_SESSION: 'BOOK_SESSION',
    EDIT_SESSION: 'EDIT_SESSION',
    CANCEL_SESSION: 'CANCEL_SESSION',
    REMINDER_SESSION: 'REMINDER_SESSION',
    SECOND_REMINDER_SESSION: 'SECOND_REMINDER_SESSION',
    MISSED_TRIAL_SESSION: 'MISSED_TRIAL_SESSION',
    BEFORE_TRIAL_CLASS: 'BEFORE_TRIAL_CLASS',
    AFTER_TRIAL_CLASS: 'AFTER_TRIAL_CLASS',
    CANCEL_SESSION_STAFF_NOTIFY: 'CANCEL_SESSION_STAFF_NOTIFY',
    EDIT_SESSION_STAFF_NOTIFY: 'EDIT_SESSION_STAFF_NOTIFY',
    BOOK_SESSION_STAFF_NOTIFY: 'BOOK_SESSION_STAFF_NOTIFY',
    AFTER_SESSION_NOTIFY: 'AFTER_SESSION_NOTIFY',
    AFTER_SESSION_STAFF_NOTIFY: 'AFTER_SESSION_STAFF_NOTIFY',
}

export const autoMessageTimeUnits = {
    HOUR: 'HOUR',
    DAY: 'DAY',
    WEEK: 'WEEK',
}
export const AFTER_SESSION_TIME_UNIT = 'MINUTE'

const filterTrialLeadAttendanceRows = (autoActions, direction, sessionType) =>
    autoActions.filter(item =>
        item.auto_actions.action === 'LEAD_ATTENDANCE' &&
        item.before_after === direction &&
        item.session_type === sessionType &&
        item.auto_action_type !== 'TASK'
    )

const openAutoMessageModal = (dispatch, messageType, sessionType = 'appointment', messageTemplateId) => {
    const box = store.getState().box.box
    const autoActions = box?.auto_actions ?? []
    let messageTypeAutoActions = []
    if (messageType === autoMessageTypes.BEFORE_TRIAL_CLASS) {
        messageTypeAutoActions = filterTrialLeadAttendanceRows(autoActions, 'BEFORE', sessionType)
    } else if (messageType === autoMessageTypes.AFTER_TRIAL_CLASS) {
        messageTypeAutoActions = filterTrialLeadAttendanceRows(autoActions, 'AFTER', sessionType)
    } else {
        messageTypeAutoActions = autoActions.filter(item => item.auto_actions.action === messageType && item.session_type === sessionType)
    }
    if (messageType === autoMessageTypes.BEFORE_TRIAL_CLASS || messageType === autoMessageTypes.AFTER_TRIAL_CLASS) {
        if (messageTemplateId) {
            messageTypeAutoActions = messageTypeAutoActions.filter(item => item.message_template?.id === messageTemplateId)
        } else if (messageTemplateId === null) {
            messageTypeAutoActions = []
        } else {
            const firstTemplateId = messageTypeAutoActions.find(item => item.message_template?.id)?.message_template?.id
            messageTypeAutoActions = firstTemplateId
                ? messageTypeAutoActions.filter(item => item.message_template?.id === firstTemplateId)
                : []
        }
    }
    dispatch(openModal({
        modalName: FLOW_MANAGER_MODAL,
        props: {
            initSelection: modalFlowOptions.SESSION_AUTO_MESSAGE,
            initProps: {messageType, sessionType, messageTemplateId: messageTemplateId ?? null},
            target: messageTypeAutoActions,
        },
    }))
}

export const getIsMessageTypeActive = (messageType, sessionType = 'appointment') => {
    const box = store.getState().box.box
    const autoActions = box?.auto_actions ?? []
    let messageTypeAutoActions = []
    if (messageType === autoMessageTypes.BEFORE_TRIAL_CLASS) {
        messageTypeAutoActions = filterTrialLeadAttendanceRows(autoActions, 'BEFORE', sessionType)
    } else if (messageType === autoMessageTypes.AFTER_TRIAL_CLASS) {
        messageTypeAutoActions = filterTrialLeadAttendanceRows(autoActions, 'AFTER', sessionType)
    } else {
        messageTypeAutoActions = autoActions.filter(item => item.auto_actions.action === messageType && item.session_type === sessionType)
    }
    return messageTypeAutoActions.some(item => item.active)
}

const getTrialLimit = () => {
    const box = store.getState().box.box
    const trialLimit = box?.settings?.[TRIAL_LIMIT_SETTING]
    return trialLimit?.limit ?? 1
}

const getMissingUserNoteIndicator = () => {
    const box = store.getState().box.box
    const missingUserNote = box?.settings?.[MISSING_USER_NOTE_INDICATOR]
    return missingUserNote?.active ?? false
}

const getAvailabilityRevealTimeSettings = () => {
    const box = store.getState().box.box
    const availabilityRevealTimeSettings = box?.settings?.[AVAILABILITY_REVEAL_TIME]
    if(availabilityRevealTimeSettings) {
        return {availabilityReveal: {revealWeeks: availabilityRevealTimeSettings.revealWeeks, revealDay: availabilityRevealTimeSettings.revealDay, revealTime: availabilityRevealTimeSettings.revealTime}}
    } else {
        return {availabilityReveal: {revealWeeks: box.showing_classes_week_ago || 0, revealDay: box.showing_classes_day_ago || 0, revealTime: box.showing_classes_time_ago || null}}
    }
}

const getWorkingHoursSettings = () => {
    const box = store.getState().box.box
    const workingHours = box?.settings?.[WORKING_HOURS_SETTING]
    const firstDayOfWeek = isBoxIL() ? 0 : 1
    return workingHours ?? {
        startDay: firstDayOfWeek,
        endDay: (firstDayOfWeek + 6) % 7,
        startTime: '05:00',
        endTime: '24:00'
    }
}

const getDefaultScheduleView = (has, hasLock) => {
    const box = store.getState().box.box
    return box?.settings?.[DEFAULT_SCHEDULE_VIEW]?.type ?? resolveDefaultScheduleType(box, has, hasLock)
}

const getWorkingHoursSubheader = () => {
    const workingHours = getWorkingHoursSettings()
    const timeFormat = getBoxTimeFormat()
    return t('working-hours-breakdown-mobile', {
        startDay: t(`days-${workingHours.startDay}`),
        endDay: t(`days-${workingHours.endDay}`),
        startTime: moment(workingHours.startTime, 'HH:mm').format(timeFormat),
        endTime: moment(workingHours.endTime, 'HH:mm').format(timeFormat)
    })
}
